module.exports = __webpack_public_path__ + "img/oceanShippingListImg_1.6f78e2b0.jpg";